import { animate, motion, useInView } from "framer-motion";
import { useEffect, useRef, useState } from "react";

const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 36, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

export function KineticLines({
  lines,
  mode = "load",
  delay = 0,
  step = 0.14,
  className = "",
  lineClassName = "",
}) {
  return (
    <>
      {lines.map((line, i) => (
        <span key={i} className={`block overflow-hidden ${className}`}>
          <motion.span
            className={`block will-change-transform ${lineClassName}`}
            initial={{ y: "112%", rotate: 3 }}
            {...(mode === "load"
              ? { animate: { y: "0%", rotate: 0 } }
              : { whileInView: { y: "0%", rotate: 0 }, viewport: { once: true, amount: 0.15 } })}
            transition={{ duration: 1.1, ease: EASE, delay: delay + i * step }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </>
  );
}

/** Counts from 00 up to `value` when it enters the viewport (works on touch scroll). */
export function CountNumber({ value, duration = 1.4, className = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.6 });
  const [display, setDisplay] = useState("00");

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration,
      ease: EASE,
      onUpdate: (v) => setDisplay(String(Math.round(v)).padStart(2, "0")),
    });
    return () => controls.stop();
  }, [inView, value, duration]);

  return (
    <span ref={ref} className={className}>
      {display}
    </span>
  );
}
